import { httpV2 } from "@/api";

/**
 * Obtém um conjunto de amostras de tendências de valores globais e tendências de frequência para um gráfico básico.
 * @param {object} parameters - Modelo contendo ids das tendências e período de tempo.
 */
const GetBasicChartData = async function(parameters)
{
	return httpV2.post("/TrendLineCharts/", parameters);
};

/**
 * Obtém um conjunto de amostras de tendências de valores globais e tendências de frequência para
 * um gráfico básico em formato de CSV.
 * @param {object} parameters - Parâmetros necessários para a requisição.
 * @returns {object} Arquivo no formato csv para download.
 */
const GetBasicChartCSV = async function(parameters)
{
	return httpV2.post("/TrendLineCharts/CSV", parameters);
};

/**
 * Obtém um array de Eventos de manutenção de cada unidade
 * @param parameters Objeto com dados para realizar a requisição.
 * @returns Array de Eventos de manutenção para diferente turbinas.
 */
const GetGeneratingUnitsMaintenanceEventTrendRecords = function(parameters =
{
	monitoringElementIds: [ 0, 0 ],
	startDateTime:        "",
	endDateTime:          ""
})
{
	return httpV2.post("/TrendLineCharts/GeneratingUnitsMaintenanceEventRecords", parameters);
};

/**
 * Obtém um conjunto de amostras de tendências de valores globais e tendências de frequência para
 * um gráfico estratificado em formato de CSV.
 * @param {object} parameters - Parâmetros necessários para a requisição.
 * @returns {object} Arquivo no formato csv para download.
 */
const GetStratifiedChartCSV = async function(parameters)
{
	return httpV2.post("/TrendLineCharts/Stratification/CSV", parameters);
};

/**
 * Obtém um conjunto de amostras de tendências de valores globais e tendências de frequência para
 * um gráfico estratificado.
 * @param {object} parameters - Parâmetros necessários para a requisição.
 */
const GetStratifiedChartData = function(parameters)
{
	return httpV2.post("/TrendLineCharts/Stratification", parameters);
};

export default {
	GetBasicChartData,
	GetBasicChartCSV,
	GetGeneratingUnitsMaintenanceEventTrendRecords,
	GetStratifiedChartCSV,
	GetStratifiedChartData,
};